import "./App.css";

const sections = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "resources", label: "Resources" },
  { id: "contact", label: "Contact" },
  { id: "policy", label: "Policies" },
];

function App() {
  return (
    <div className="app-shell">
      <nav className="primary-nav">
        <span className="logo">Killmoe Music</span>
        <ul>
          {sections.map((section) => (
            <li key={section.id}>
              <a href={`#${section.id}`}>{section.label}</a>
            </li>
          ))}
        </ul>
      </nav>

      <header className="hero" id="about" style={{ backgroundImage: 'url("/images/hero-bg.jpg")' }}>
        <img src="/uploads/hero.jpg" alt="Killmoe Music - Connecting listeners with emerging artists" className="hero-banner" style={{ width: '100%', maxHeight: '400px', objectFit: 'cover' }} />
        <p className="eyebrow">Killmoe Music · Elevate Your Sound</p>
        <h1>Welcome to Killmoe Music</h1>
        <p className="lede">
          At Killmoe Music, we believe in the transformative power of sound. Our mission is to empower artists and music enthusiasts with the tools and resources they need to create, share, and enjoy music in all its forms. Whether you're a budding musician or a seasoned pro, our platform offers a wealth of opportunities to amplify your creativity and reach your audience.
        </p>
        <p>
          Explore our extensive library of resources, including tutorials, articles, and the latest news in the music industry. Join our vibrant community of passionate individuals who share your love for music and creativity. We are dedicated to fostering an environment where artists can thrive, collaborate, and innovate. Our commitment to quality and excellence is reflected in everything we do, from our production services to our artist development programs.
        </p>
        <p>
          Dive into our blog for insights on the latest trends in music, tips for aspiring musicians, and stories from industry veterans. Our team curates content that inspires and educates, ensuring you have access to the best information available. Whether you're looking to improve your skills or simply enjoy the art of music, Killmoe Music is here to support you every step of the way.
        </p>
        <p>
          Join us in celebrating the vibrant world of music. Together, we can create, share, and enjoy the sounds that move us. Let’s make music that resonates and connects with audiences everywhere. Our community is built on collaboration, creativity, and a shared passion for the art of sound. We invite you to explore our resources, engage with fellow artists, and take your musical journey to new heights.
        </p>
        <p>
          As you navigate through our site, you'll find a plethora of articles that cover everything from music theory to the latest production techniques. Our blog features posts like "5 Tips for Budding Musicians," which provides practical advice for those just starting out, and "The Evolution of Music Production," which delves into how technology has transformed the industry. Additionally, "How to Promote Your Music Online" offers strategies to help you reach a wider audience and build your brand.
        </p>
        <div className="cta-row">
          <a href="/blog" className="cta-button">Read Our Blog</a>
          <a href="/contact" className="secondary">Get in Touch</a>
        </div>
        <img src="/images/music-creation.jpg" alt="Music Creation" className="hero-image" />
      </header>

      <section className="cards" id="services">
        <article>
          <h2>Music Production</h2>
          <p>
            Our state-of-the-art production services help you bring your musical vision to life. From recording to mixing and mastering, we provide the expertise you need to create professional quality tracks.
          </p>
        </article>
        <article>
          <h2>Artist Development</h2>
          <p>
            We offer personalized coaching and development programs to help artists hone their skills, build their brand, and navigate the music industry effectively.
          </p>
        </article>
        <article>
          <h2>Live Events</h2>
          <p>
            Join us for live performances and events that showcase emerging talent. Experience the thrill of live music and connect with fellow music enthusiasts.
          </p>
        </article>
        <article>
          <h2>Music Licensing</h2>
          <p>
            Our licensing services ensure that your music is heard in films, commercials, and other media, providing you with new revenue streams and exposure.
          </p>
        </article>
      </section>

      <section className="resources" id="resources">
        <div className="resource-card">
          <h3>Latest Blog Posts</h3>
          <p>Check out our latest articles:</p>
          <ul>
            <li><a href="/blog/5-tips-for-budding-musicians">5 Tips for Budding Musicians</a></li>
            <li><a href="/blog/the-evolution-of-music-production">The Evolution of Music Production</a></li>
            <li><a href="/blog/how-to-promote-your-music-online">How to Promote Your Music Online</a></li>
          </ul>
        </div>
        <div className="resource-card">
          <h3>Documentation</h3>
          <p>Explore our comprehensive guides on music production and artist development.</p>
        </div>
        <div className="resource-card">
          <h3>Contact & Legal</h3>
          <p>Find our About, Contact, Terms, and Privacy pages for more information.</p>
        </div>
      </section>

      <section className="contact" id="contact">
        <div>
          <h2>Contact Us</h2>
          <p>If you have questions or need assistance, reach out to us!</p>
          <ul>
            <li>Email: support@killmoemusic.com</li>
            <li>Phone: (123) 456-7890</li>
            <li>Location: Your City, USA</li>
          </ul>
        </div>
        <form>
          <label>
            Name
            <input type="text" placeholder="Jane Doe" required />
          </label>
          <label>
            Email
            <input type="email" placeholder="you@example.com" required />
          </label>
          <label>
            Message
            <textarea rows={4} placeholder="How can we help?" required />
          </label>
          <button type="submit">Send Message</button>
        </form>
      </section>

      <section className="policies" id="policy">
        <h2>Policies & Compliance</h2>
        <p>
          This site includes essential compliance resources. Customize the linked pages in{" "}
          <code>public/</code> to match your organization.
        </p>
        <ul className="policy-links">
          <li><a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a></li>
          <li><a href="/terms" target="_blank" rel="noreferrer">Terms of Service</a></li>
          <li><a href="/contact" target="_blank" rel="noreferrer">Contact</a></li>
          <li><a href="/about" target="_blank" rel="noreferrer">About</a></li>
        </ul>
      </section>

      <div id="adsense" className="adsense-slot">
        <p>AdSense placeholder — replace with your ad code.</p>
      </div>

      <footer className="footer">
        <p>Informational only. All rights reserved © Killmoe Music 2023.</p>
        <p>Disclaimer: The information provided on this site is for educational purposes only and does not constitute professional advice.</p>
      </footer>
    </div>
  );
}

export default App;